import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'Clock',
  values: {
    timeFormat: 'LONG_TIME',
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '80px',
        },
      },
    },
    time: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          flexShrink: 1,
        },
      },
    },
    offset: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          flexShrink: 1,
        },
      },
    },
    isOffsetHidden: true,
  },
  meta: {
    extendable: false,
  },
}
